﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function userportalmenu(context) {
  const toggleButton = context.querySelector('.aimo-login__options');
  const selectionElement = context.querySelector('ol');
  const selectionElementLinks = selectionElement ? selectionElement.querySelectorAll('a') : [];

  function init() {
    if (!toggleButton)
      return;

    toggleButton.addEventListener('click', function(event) {
      toggleButton.classList.toggle('active');
      selectionElement.classList.toggle('active');
      event.preventDefault();

      loopSelectionLinks(selectionElement.classList.contains('active'));

      if(toggleButton.classList.contains('active')) {
        setTimeout(function () {
          document.addEventListener("click", closeLanguageSelection);
        }, 250);

        if (document.querySelector('html').classList.contains('navigation-active')) {
          const navigationWrapperElement = document.querySelector('.aimo-navigation');
          const navigationScrollHeight = navigationWrapperElement.scrollHeight;
          const navigationClientHeight = navigationWrapperElement.clientHeight;

          navigationWrapperElement.scrollTop = navigationScrollHeight - navigationClientHeight;
				}
      } else {
        document.removeEventListener("click", closeLanguageSelection);
      }
    });
  }

	const loopSelectionLinks = function (isActive) {
    for (let i = 0; i < selectionElementLinks.length; i++) {
      const singleSelectionElementLink = selectionElementLinks[i];
      if (!isActive)
        singleSelectionElementLink.setAttribute('tabindex', '-1');
      else
        singleSelectionElementLink.removeAttribute('tabindex');
    }
	}

  const closeLanguageSelection = function(e) {
    if (e.target !== selectionElement && !isDescendant(selectionElement, e.target)) {
      toggleButton.classList.remove('active');
      selectionElement.classList.remove('active');
      loopSelectionLinks(false);

      document.removeEventListener("click", closeLanguageSelection);
    }
  }

  const isDescendant = function(parent, child) {
    var node = child.parentNode;
    while (node !== null) {
      if (node === parent)
          return true;

      node = node.parentNode;
    }
    return false;
  }

  return {
    init
  };
}

controller.add('aimo-header-userportal', userportalmenu);